import { Button, Loader } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

import { LinkedEntitiesSection } from 'src/Components/EntityLinks/LinkedEntitiesSection';
import { LinkTrail } from 'src/Components/EntityLinks/LinkTrail';
import { CommunityFeedItem } from 'src/Containers/Community/CommunityHome/CommunityFeed/CommunityFeedItem';
import useFetchSingleFeedItem from 'src/Hooks/Queries/useFetchSingleFeedItem';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { LinkableEntityType } from 'src/Services/API/EntityLinks.api';
import { CommunityFeedItemDtoTypeEnum } from 'src/Services/API/generated';

import styles from './CommunityFeedItemDetailPage.module.scss';

type FeedItemParms = {
  postId: string;
  commentId?: string;
};

const CommunityFeedItemDetailPage = () => {
  const assetId = useCurrentAssetId();
  const { t } = useTranslation();

  const { postId, commentId } = useParams<FeedItemParms>();

  const { data: feedItem, isLoading, isError } = useFetchSingleFeedItem(postId as string);

  if (isLoading || feedItem === undefined) {
    return <Loader />;
  }

  if (isError) {
    return <div>{t('community.feedDetailError', 'Impossible de récupérer la publication.')}</div>;
  }
  return (
    <>
      <div className={styles.container}>
        <Link to={`/asset/${assetId}/community`}>
          <Button variant={'transparent'} leftSection={<IconArrowLeft width={18} height={18} />}>
            {t('common.myCommunityGoBack', 'Retour à ma communauté')}
          </Button>
        </Link>
        <div className={styles.subContainer}>
          <LinkTrail />
          <CommunityFeedItem
            feedItem={feedItem}
            areCommentsOpenByDefault={true}
            highlightedCommentId={commentId}
          />
          {/* Only memories get a "Lié à" panel; ordinary messages are reached from the wall. */}
          {feedItem.type === CommunityFeedItemDtoTypeEnum.PostMemory && (
            <LinkedEntitiesSection
              entityType={LinkableEntityType.CommunityFeedItem}
              entityId={feedItem.id}
              entityTitle={(feedItem.content.fr ?? feedItem.content.en)?.trim() || undefined}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default CommunityFeedItemDetailPage;
